export enum TamanhoIconeEnum {
  XXSMALL = '16px',
  XSMALL = '20px',
  SMALL = '24px ',
  MEDIUM = '32px',
  LARGE = '40px ',
  XLARGE = '48px',
  BIG = '80px',
}
